"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileTypeDes = exports.FileType = void 0;
var FileType;
(function (FileType) {
    FileType[FileType["DOC"] = 1] = "DOC";
    FileType[FileType["SHEET"] = 2] = "SHEET";
    FileType[FileType["SLIDE"] = 3] = "SLIDE";
    FileType[FileType["FORM"] = 4] = "FORM";
    FileType[FileType["PDF"] = 5] = "PDF";
    FileType[FileType["SUITE"] = 7] = "SUITE";
    FileType[FileType["RESUME"] = 8] = "RESUME";
    FileType[FileType["SMART_CANVAS"] = 9] = "SMART_CANVAS";
    FileType[FileType["MIND"] = 10] = "MIND";
    FileType[FileType["FLOWCHART"] = 11] = "FLOWCHART";
})(FileType = exports.FileType || (exports.FileType = {}));
var FileTypeDes;
(function (FileTypeDes) {
    FileTypeDes["DOC"] = "doc";
    FileTypeDes["FORM"] = "form";
    FileTypeDes["PDF"] = "pdf";
    FileTypeDes["SHEET"] = "sheet";
    FileTypeDes["SLIDE"] = "slide";
    FileTypeDes["SUITE"] = "suite";
    FileTypeDes["RESUME"] = "resume";
    FileTypeDes["SMART_CANVAS"] = "smart-canvas";
    FileTypeDes["MIND"] = "mind";
    FileTypeDes["FLOWCHART"] = "flowchart";
})(FileTypeDes = exports.FileTypeDes || (exports.FileTypeDes = {}));
//# sourceMappingURL=enum.js.map